import styled from 'styled-components';

const ToolTitle = styled.div`
  display: flex;
  padding: 0 0 0 8px;
  align-items: center;
  align-self: stretch;
  color: #212b36;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  user-select: none;
`;

export default ToolTitle;
